/* Concepts:

- When game is initialized, generate first 30 levels.
- Each time player moves, run obstacleService.generate to generate a new obstacle or free tile.
- Each time player moves, clean up any obstacles that are no longer visible.

As level increases, difficulty increases by:
    - increasing speed of obstacles
    - increasing frequency of obstacles
    - increasing number of obstacles per row

Main functions:
initialize() ->  sets up the game board
cleanup() -> removes rendered obstacles that are no longer visible
generate() -> generates 1 new tile based on the current level




 */

import {get} from "svelte/store";
import {currentLevel, obstacleGenerationLevel, grid, scene, obstacles} from "@src/appStore";
import {GameObjects} from "phaser";

function handleCollision(event) {
    console.log("collide!", event)
}

export function initialize(sloth: GameObjects.Image) {
    const initialLevels = 30;
    let curr = get(obstacleGenerationLevel);
    const gameScene = get(scene);

    const initialObstacles = gameScene?.physics.add.group();
    gameScene?.physics.add.collider(sloth, initialObstacles, handleCollision, null, this);


    if (initialObstacles)
        obstacles.set(initialObstacles);

    while (curr <= initialLevels) {
        addEagle(curr);
        curr++;
        obstacleGenerationLevel.set(curr);
    }
}

function addEagle(level: number) {
    setTimeout(() => {
        const eagle = get(scene)!.physics.add.image(0, 0, "eagle");
        eagle.setDisplaySize(128, 128);
        eagle.setDepth(5);
        get(grid)!.patrol({
            obj: eagle,
            xLeft: 0,
            xRight: 4,
            xInitial: Phaser.Math.Between(0, 3),
            y: -level
        });
        const obs = get(obstacles);
        obs.add(eagle);
    }, Phaser.Math.Between(0, 0));

}

currentLevel.subscribe(handleLevelChange)



function handleLevelChange() {
    // cleanup();
    // generate();
}